import React from "react";
import LandingScreen from "./components/landing-screen.component";
import LoaderComponent from "./components/loader/loader.component";
import { injectAsyncScripts } from "./utils/async-scripts";

export default class App extends React.Component {
  state = {
    loading: false
  };

  constructor() {
    super();
    injectAsyncScripts();
  }

  showUILoader = (loaderFlag) => {
    this.setState({
      loading: loaderFlag
    });
  };

  render() {
    return (
      <React.Fragment>
        <LandingScreen showUILoader={this.showUILoader} />
        {this.state.loading && <LoaderComponent />}
      </React.Fragment>
    );
  }
}
